import { render, staticRenderFns } from "./Assign-reviewer.vue?vue&type=template&id=0019f5e8"
import script from "./Assign-reviewer.vue?vue&type=script&lang=js"
export * from "./Assign-reviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports